module.exports = __webpack_public_path__ + "img/_can_.44d0f494.svg";